const gradients = {
    light: "linear-gradient(135deg, #e6e9f0 0%, #eef1f5 100%)",
    dark: "linear-gradient(135deg, #434343 0%, black 100%)",
    red: "linear-gradient(135deg, hsla(333, 100%, 53%, 1) 0%, hsla(33, 94%, 57%, 1) 100%)",
    orange: "linear-gradient(135deg, hsla(42, 93%, 57%, 1) 0%, hsla(358, 78%, 62%, 1) 100%)",
    yellow: "linear-gradient(135deg, hsla(33, 100%, 53%, 1) 0%, hsla(58, 100%, 68%, 1) 100%)",
    green: "linear-gradient(135deg, hsla(59, 86%, 68%, 1) 0%, hsla(134, 36%, 53%, 1) 100%)",
    cyan: "linear-gradient(135deg, hsla(206, 91%, 66%, 1) 0%, hsla(190, 90%, 51%, 1) 100%)",
    blue: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)",
    purple: "linear-gradient(135deg, hsla(238, 100%, 71%, 1) 0%, hsla(295, 100%, 84%, 1) 100%)",
    pink: "linear-gradient(135deg, #b8cbb8 0%, #b8cbb8 0%, #b465da 0%, #cf6cc9 33%, #ee609c 66%, #ee609c 100%)",
    teal: "linear-gradient(135deg, hsla(173, 89%, 70%, 1) 0%, hsla(196, 68%, 38%, 1) 100%)",
    coral: "linear-gradient(135deg, #f78ca0 0%, #f9748f 19%, #fd868c 60%, #fe9a8b 100%)",
    brown: "linear-gradient(to top, #c79081 0%, #dfa579 100%)",
    magenta:
        "linear-gradient(135deg, hsla(333, 100%, 53%, 1) 0%, hsla(238, 100%, 71%, 1) 100%)",
};

export default gradients;
